import api from '@/api'

const store = {
  state: {
    dataMenuGroupSchedule: [],
    pagingMenuGroupSchedule: {
      page: 1,
      size: 20,
      total: 0
    },
    sortingMenuGroupSchedule: {
      byField: '',
      isDesc: false
    },
    filteringMenuGroupSchedule: {
      outletCode: null,
      menuGroupCode: null,
      status: null,
      beginDate: null,
      endDate: null,
      beginDay: null,
      endDay: null,
      beginHour: null,
      endHour: null
    }
  },

  mutations: {
    SET_SALEMENUSCHEDULE: (state, payload) => {
      state.dataMenuGroupSchedule = payload
    },
    SET_PAGING_PAGE_SALEMENUSCHEDULE: (state, payload) => {
      state.pagingMenuGroupSchedule.page = payload
    },
    SET_PAGING_TOTAL_SALEMENUSCHEDULE: (state, payload) => {
      state.pagingMenuGroupSchedule.total = payload
    },
    SET_SORTING_SALEMENUSCHEDULE: (state, payload) => {
      state.sortingMenuGroupSchedule = payload
    },
    SET_FILTERING_SALEMENUSCHEDULE: (state, payload) => {
      state.filteringMenuGroupSchedule = payload
    }
  },

  getters: {
    SortingMenuGroupSchedule: state => state.sortingMenuGroupSchedule,
    FilteringMenuGroupSchedule: state => state.filteringMenuGroupSchedule,
    PagingMenuGroupSchedule: state => state.pagingMenuGroupSchedule,
    GetAllMenuGroupSchedule: state => state.dataMenuGroupSchedule,
    GetOneMenuGroupSchedule: state => id =>
      state.dataMenuGroupSchedule.find(
        dataMenuGroupSchedule => dataMenuGroupSchedule.id === id
      )
  },

  actions: {
    async UpdateSortingMenuGroupSchedule({ commit, dispatch }, payload) {
      commit('SET_SORTING_SALEMENUSCHEDULE', {
        byField: payload.byField,
        isDesc: payload.isDesc
      })
      dispatch('GetAllMenuGroupSchedule')
    },

    async UpdateFilteringMenuGroupSchedule({ commit, dispatch }, isResetField) {
      if (isResetField) {
        const emptyFilter = {
          cond: null,
          code: null,
          description: null
        }
        commit('SET_FILTERING_SALEMENUSCHEDULE', emptyFilter)
      }
      commit('SET_PAGING_PAGE_SALEMENUSCHEDULE', 1)
      dispatch('GetAllMenuGroupSchedule')
    },

    async GetAllMenuGroupSchedule({ commit, state }) {
      try {
        commit('SET_IS_FETCHING_DATA', true)
        const result = await api.GetAllMenuGroupSchedule(
          state.pagingMenuGroupSchedule,
          state.sortingMenuGroupSchedule,
          state.filteringMenuGroupSchedule
        )
        commit('SET_IS_FETCHING_DATA', false)
        commit(
          'SET_PAGING_TOTAL_SALEMENUSCHEDULE',
          result.headers['data-length']
        )
        commit('SET_SALEMENUSCHEDULE', result.data.data.data)
        return result.data.data
      } catch (e) {
        commit('SET_IS_FETCHING_DATA', false)
        throw e
      }
    },

    async CreateMenuGroupSchedule({ dispatch }, payload) {
      try {
        const { data } = await api.CreateMenuGroupSchedule(payload)
        dispatch('GetAllMenuGroupSchedule')
        return data
      } catch (e) {
        return e.response
      }
    },

    async UpdateMenuGroupSchedule({ dispatch }, payload) {
      try {
        const { data } = await api.UpdateMenuGroupSchedule(payload.id, payload)
        dispatch('GetAllMenuGroupSchedule')
        return data
      } catch (e) {
        return e.response
      }
    },

    async DeleteMenuGroupSchedule({ dispatch }, id) {
      try {
        const { data } = await api.DeleteMenuGroupSchedule(id)
        dispatch('GetAllMenuGroupSchedule')
        return data
      } catch (e) {
        return e.response
      }
    }
  }
}

export default store
